import { DYNAMIC_CALCULATION_DATA_FIELD_KEY_PREFIX } from '../../constants/dataFieldKeys/dynamicCalculationDataFieldKey';

export const isDynamicCalculation = (key: string): boolean => {
  return key.indexOf(DYNAMIC_CALCULATION_DATA_FIELD_KEY_PREFIX) > -1;
};
